import {applyMiddleware, createStore} from "redux";
import {composeWithDevTools} from "redux-devtools-extension";

import reducers from "./reducers";
import {appMiddleware} from "./middleware";

export default (localStorage) =>
    createStore(
        reducers,
        localStorage,
        composeWithDevTools(applyMiddleware(appMiddleware))
    );


// WEBPACK FOOTER //
// ./src/redux/store.js